import React from 'react';
import { View, type ViewInstance } from 'react-native';

import { measureView } from './useMeasuredView.utils';

import type { MeasureViewProps } from './useMeasuredView.types';

export const MeasuredView = (props: MeasureViewProps) => {
  const { initialMeasureOnly, width, height, setWidth, setHeight } = props;
  const reference = React.useRef<ViewInstance>(null);
  const onLayout = React.useCallback(() => {
    measureView({
      reference,
      initialMeasureOnly,
      width,
      height,
      setWidth,
      setHeight,
    });
  }, [reference, initialMeasureOnly, width, height, setWidth, setHeight]);

  return <View ref={reference} onLayout={onLayout} {...props} />;
};
